export default __webpack_public_path__ + "static/media/cal_bg12.3ca1ce16.jpg";